import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { storedDateForDisplay } from './stored-date';

@Pipe({ name: 'swedishDate', standalone: false })
export class SwedishDatePipe implements PipeTransform {

  transform(value: string | number | Date | null | undefined, format?: string, _timezone?: string, locale = 'sv-SE'): string | null {
    if (value == null) {
      return null;
    }

    const date = storedDateForDisplay(value);
    if (isNaN(date.getTime())) {
      return null;
    }

    return new DatePipe(locale).transform(date, format, '+0000', locale);
  }

}
